
import React, { useState } from "react";
import { Modal, Box, Button, Typography, IconButton } from "@mui/material";
import { toast } from "react-hot-toast";
import { BASE_URL } from "../../../../components/BaseUrl";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import Webcam from "react-webcam";
const EvidenceModal = ({ open, onClose, onSave }) => {
  const [files, setFiles] = useState([]);
  const { t } = useTranslation();

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };
const [cameraOpen, setCameraOpen] = useState(false);
const webcamRef = React.useRef(null);
  const removeFile = (index) => {
    const updated = [...files];
    updated.splice(index, 1);
    setFiles(updated);
  };

  const handleUpload = async () => {
    if (files.length === 0) {
toast.error(t("evidence.selectFile"));
      return;
    }

    try {
      const uploadedUrls = [];

      for (let file of files) {
        const formData = new FormData();

        // check type
        const isPdf = file.type === "application/pdf";
        const fieldKey = isPdf ? "pdf" : "image";

        formData.append(fieldKey, file);

        // choose endpoint based on type
        const endpoint = isPdf
          ? `${BASE_URL}/upload/pdf`
          : `${BASE_URL}/upload/image`;

        const res = await fetch(endpoint, {
          method: "POST",
          body: formData,
        });

        const data = await res.json();

        if (!data.error && data.data?.url) {
          uploadedUrls.push(data.data.url);
        }
      }

      if (uploadedUrls.length > 0) {
toast.success(t("evidence.uploadSuccess"));
        onSave(uploadedUrls);
        setFiles([]);
        onClose();
      } else {
toast.error(t("evidence.noFiles"));
      }
    } catch (err) {
      console.error("❌ Upload error:", err);
toast.error(t("evidence.uploadError"));
    }
  };

  return (
    <>
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          bgcolor: "white",
          p: 3,
          borderRadius: 4,
          maxWidth: 450,
          mx: "auto",
          mt: 10,
          textAlign: "center",
        }}
      >
        <Typography
          fontWeight={600}
          sx={{
            color: "#2C384C",
            fontSize: "22px",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {t("evidenceModal.title")}
        </Typography>

        <Typography
          sx={{
            mb: 2,
            color: "#8B8D97",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
          }}
        >
          {t("evidenceModal.subtitle")}
        </Typography>
<Box
  sx={{
    display: "flex",
    justifyContent: "flex-end",
    mb: 1,
  }}
>
  <Typography
    sx={{
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
      color: "#006EC2",
      cursor: "pointer",
      textDecoration: "underline",
    }}
    onClick={() => setCameraOpen(true)}
  >
    {t("evidenceModal.takePhoto")}
  </Typography>
</Box>
        {/* File upload box */}
        <Box
          sx={{
            border: "2px dashed #ccc",
            p: 4,
            py: 6,
            borderRadius: 2,
            mb: 2,
            cursor: "pointer",
          }}
        >
          <input
            type="file"
            accept="application/pdf,image/*"
            multiple
            onChange={handleFileChange}
            style={{ display: "none" }}
            id="evidence-upload"
          />
          <label htmlFor="evidence-upload" style={{ cursor: "pointer" }}>
            <Typography
              sx={{
                fontSize: "19px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 500,
                color: "#626F86",
              }}
            >
              {t("evidenceModal.clickToBrowse")}
            </Typography>
          </label>
        </Box>

        {/* Selected files list */}
        {files.length > 0 && (
          <Box sx={{ mb: 2 }}>
            {files.map((file, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "1px solid #E4E6EF",
                  borderRadius: 1,
                  p: 1,
                  mt: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    fontFamily: "Poppins, sans-serif",
                    wordBreak: "break-all",
                  }}
                >
                  {file.name}
                </Typography>
                <IconButton
                  onClick={() => removeFile(i)}
                  size="small"
                  sx={{
                    color: "#FF4C4C",
                    "&:hover": { color: "red" },
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        )}

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mt: 3,
            alignItems: "center",
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              fontSize: 15,
              textTransform: "none",
              borderRadius: "5px",
              fontFamily: "Poppins, sans-serif",
              color: "#006EC2",
              border: "2px solid #006EC2",
              px: 3,
              py: 1,
              height: "42px",
            }}
          >
            {t("evidenceModal.cancel")}
          </Button>

          <Button
            variant="contained"
            onClick={handleUpload}
            sx={{
              fontSize: 15,
              textTransform: "none",
              borderRadius: "5px",
              fontFamily: "Poppins, sans-serif",
              backgroundColor: "#006EC2",
              color: "#fff",
              px: 4,
              py: 1,
              height: "42px",
              "&:hover": {
                backgroundColor: "#005bb5",
              },
            }}
          >
            {t("evidenceModal.save")}
          </Button>
        </Box>
      </Box>
    </Modal>
    <Modal open={cameraOpen} onClose={() => setCameraOpen(false)}>
  <Box
    sx={{
      bgcolor: "white",
      p: 3,
      borderRadius: 3,
      maxWidth: 400,
      mx: "auto",
      mt: 10,
      textAlign: "center",
    }}
  >
    <Typography
      sx={{
        fontSize: "18px",
        fontWeight: 600,
        mb: 2,
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {t("evidenceModal.takePhoto")}
    </Typography>

    <Webcam
      ref={webcamRef}
      audio={false}
      screenshotFormat="image/jpeg"
      width="100%"
    />

    <Box sx={{ display: "flex", justifyContent: "center",gap:2, mt: 2 }}>
      <Button
      sx={{           fontFamily: 'Poppins, sans-serif',textTransform:"capitalize"
}}
        variant="outlined"
        onClick={() => setCameraOpen(false)}
      >
        {t("evidenceModal.cancel")}
      </Button>

      <Button
      sx={{           fontFamily: 'Poppins, sans-serif',textTransform:"capitalize"
}}
        variant="contained"
        onClick={() => {
          const imageSrc = webcamRef.current.getScreenshot();
          if (!imageSrc) return;

          // convert base64 → File
          fetch(imageSrc)
            .then(res => res.blob())
            .then(blob => {
              const file = new File(
                [blob],
                `camera_${Date.now()}.jpg`,
                { type: "image/jpeg" }
              );

              setFiles(prev => [...prev, file]);
              setCameraOpen(false);
            });
        }}
      >
        {t("evidenceModal.capture")}
      </Button>
    </Box>
  </Box>
</Modal>
</>
  );
};

export default EvidenceModal;
